import extendNode from '../extendNode.mjs'
import Color from '../Color.mjs'
import useProductNode from '../_PRODUCT/useProductNode.jsx'
import meta from './metaChg.mjs'
import Model from './ModelChg.mjs'
import PropertiesPane from './PropertiesPaneChg.jsx'
import api from './apiChg.mjs'

export default () => {
    const ProductNode = useProductNode()

    return extendNode(ProductNode, {
        ...meta,
        api,
        Model,
        PropertiesPane,

        _getCategories(map, node) {
            return [
                'CHG_CHG',
                'CHG_DOC',
            ]
        },

        _getThemeColor(map, node) {
            return Color.LIGHT_GREY
        },
    })
}
